<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref=""></ion-back-button>
    </ion-buttons>
    <ion-title>
      <span translate>Connection</span>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item>
      <ion-label class="ion-text-wrap" translate>
        Connection timeout
      </ion-label>
      <ion-range slot="end" [(ngModel)]="ranges.connection" min="1000" max="5000" step="500" snaps="true">
        <ion-label slot="start">1 s</ion-label>
        <ion-label slot="end">5 s</ion-label>
      </ion-range>
    </ion-item>
    <ion-item>
      <ion-label class="ion-text-wrap" translate>
        Request timeout
      </ion-label>
      <ion-range slot="end" [(ngModel)]="ranges.request" min="1000" max="5000" step="500" snaps="true">
        <ion-label slot="start">1 s</ion-label>
        <ion-label slot="end">5 s</ion-label>
      </ion-range>
    </ion-item>
    <ion-item>
      <ion-label class="ion-text-wrap" translate>
        Reconnect delay
      </ion-label>
      <ion-range slot="end" [(ngModel)]="ranges.reconnect" dualKnobs="true" min="2000" max="10000" step="1000" snaps="true">
        <ion-label slot="start">2 s</ion-label>
        <ion-label slot="end">10 s</ion-label>
      </ion-range>
    </ion-item>
    <ion-item>
      <ion-label class="ion-text-wrap" translate>
        Demo Control Unit
      </ion-label>
      <ion-toggle [(ngModel)]="demo"></ion-toggle>
    </ion-item>
  </ion-list>
</ion-content>
